export class TooltipItem {
    public labelText = '';
    public labelClass = '';
    public contentText = '';
    public contentClass = '';

    constructor(labelText?: string, contentText?: string) {
        if (labelText) {
            this.labelText = labelText;
        }

        if (contentText) {
            this.contentText = contentText;
        }
    }
}